import { fetchPushPublicKey, subscribeToPush } from "./api";

export async function registerServiceWorker(): Promise<ServiceWorkerRegistration | null> {
  if (!("serviceWorker" in navigator)) {
    return null;
  }

  try {
    return await navigator.serviceWorker.register("/service-worker.js", { scope: "/" });
  } catch (error) {
    return null;
  }
}

export async function ensurePushSubscription(
  registration: ServiceWorkerRegistration | null
): Promise<PushSubscription | null> {
  if (!registration || !("pushManager" in registration)) {
    return null;
  }

  if (Notification.permission === "denied") {
    return null;
  }

  if (Notification.permission !== "granted") {
    const result = await Notification.requestPermission();
    if (result !== "granted") {
      return null;
    }
  }

  const publicKey = await fetchPushPublicKey();
  if (!publicKey) {
    return null;
  }

  const existing = await registration.pushManager.getSubscription();
  if (existing) {
    return existing;
  }

  try {
    const subscription = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToBuffer(publicKey)
    });
    await subscribeToPush(subscription);
    return subscription;
  } catch (error) {
    return null;
  }
}

function urlBase64ToBuffer(input: string): ArrayBuffer {
  const padding = "=".repeat((4 - (input.length % 4)) % 4);
  const base64 = (input + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = atob(base64);
  const buffer = new ArrayBuffer(raw.length);
  const view = new Uint8Array(buffer);
  for (let i = 0; i < raw.length; i += 1) {
    view[i] = raw.charCodeAt(i);
  }
  return buffer;
}
